import { TabPanel, TabView } from "primereact/tabview";
import constantes from "../../catalogos/constantes";
import useSeguridad from "../../Seguridad/useSeguridad";
import useSessionState from "../../hooks/useSessionState";
import SalidasEmpleado from "./salidasEmpleado";

const SalidasEmpleadoSecciones = () => {
    const seguridad = useSeguridad();

    const soloLectura = !seguridad.esEditable(constantes.menus.salidasEmpleado);

    const [activeIndex, setActiveIndex] = useSessionState("tabSalidasEmpleado", 0);

    return (
        <>
            <TabView
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
                className="main-tab-view"
            >
                <TabPanel
                    headerStyle={
                        seguridad.tieneAcceso(constantes.menus.salidasEmpleado) || soloLectura
                            ? { display: "inline" }
                            : { display: "none" }
                    }
                    header="Pases de salida"
                >
                    <SalidasEmpleado
                        esSeccionAutorizar={false}
                        soloLectura={soloLectura}
                    />
                </TabPanel>

                <TabPanel
                    headerStyle={
                        seguridad.tieneAcceso(constantes.menus.pasesPorAutorizarSalidasEmpleado)
                            ? { display: "inline" }
                            : { display: "none" }
                    }
                    header="Pases por autorizar"
                >
                    <SalidasEmpleado
                        esSeccionAutorizar={true}
                        soloLectura={soloLectura}
                    />
                </TabPanel>
            </TabView>
        </>
    );
};

export default SalidasEmpleadoSecciones;